<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form method="#" action="#">
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <fade-render-transition>
            <card>
              <vue-element-loading
                :text="loading.text"
                spinner="ring"
                :color="loading.color"
                :active="loading.active"
                :is-full-screen="false"/>
              <div slot="header">
              </div>
              <div>
                <fg-input label="usuario"
                          placeholder="Usuario Administrador"
                          type="text"
                          v-model="model.usuario"
                          v-validate="modelValidations.usuario"
                          :error="getError('username')"
                          name="username">

                </fg-input>
                <fg-input label="passsword"
                          type="password"
                          placeholder="Password"
                          v-model="model.password"
                          v-validate="modelValidations.password"
                          :error="getError('password')"
                          name="password"
                          ref="password">
                </fg-input>
                <!--                 <fg-input>
                                  <l-checkbox v-model="model.subscribe">
                                    Subscribe to newsletter
                                  </l-checkbox>
                                </fg-input> -->
              </div>
              <div class="text-center">
                <button type="submit" @click.prevent="validate" class="btn btn-fill btn-primary btn-round btn-md ">
                  Acceder
                </button>
                <br>
              </div>
            </card>
          </fade-render-transition>

        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
    import {Checkbox as LCheckbox, FadeRenderTransition} from 'src/components/index'
    import AuthLayout from './AuthLayout.vue'
    import VueElementLoading from 'vue-element-loading'
    import swal from 'sweetalert2'

    export default {
        components: {
            LCheckbox,
            FadeRenderTransition,
            AuthLayout,
            VueElementLoading
        },
        data() {
            return {
                loading: {
                    text: 'Please Wait',
                    color: '#222',
                    active: false
                },
                model: {
                    usuario: '',
                    password: ''
                },
                modelValidations: {
                    usuario: {
                        required: true,
                        min: 3
                    },
                    password: {
                        required: true,
                        min: 6,
                        max: 20
                    }
                }
            }
        },
        methods: {
            showSwal(type, message) {
                if (type === 'error') {
                    swal.fire({
                        title: message,
                        type: 'warning'
                    })
                }
            },
            login() {
                this.loading.active = true;
                this.axios({
                    url: 'verificacion.php',
                    method: 'post',
                    data: this.model
                })
                    .then(response => {
                        this.loading.active = false;
                        localStorage.setItem('token', response.data.message.token);
                        let name = response.data.message.name;
                        let mail = response.data.message.mail;
                        const userdata = {
                            name,
                            mail
                        };
                        localStorage.setItem('account', JSON.stringify(userdata));
                        localStorage.setItem('vposAppAuth', true);
                        this.$router.replace('/')
                    })
                    .catch(error => {
                        this.loading.active = false;
                        this.model.password = '';
                        this.$refs.password.$el.children[1].focus();
                        this.showSwal('error', 'Usuario no existe')
                    })
            },
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid)
                        this.login();
                })
            },
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            toggleNavbar() {
                document.body.classList.toggle('nav-open')
            },
            closeMenu() {
                document.body.classList.remove('nav-open');
                document.body.classList.remove('off-canvas-sidebar')
            }
        },
        created() {
            localStorage.clear()
        },
        beforeDestroy() {
            this.closeMenu()
        }
    }
</script>
<style>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
